import { useCreateOrgMutation } from "@src/features/app/dialogs/orgManagement/CreateOrgDialog.generated";
import OrgForm from "@src/features/app/dialogs/orgManagement/OrgForm";
import { useOrgFormState } from "@src/features/app/dialogs/orgManagement/useOrgFormState";
import useSwitchOrgAndReload from "@src/features/app/hooks/useSwitchOrgAndReload";
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@src/lib/ui/Dialog";
import { Button } from "@src/lib/ui/Button";
import ScrollableFlexGrow from "@src/lib/ui/ScrollableFlexGrow";
import gql from "graphql-tag";
import { DateTime } from "luxon";
import { FC } from "react";

type Props = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
};

const CreateOrgDialog: FC<Props> = ({ open, onOpenChange }) => {
  const state = useOrgFormState();
  const { switchOrgAndReload } = useSwitchOrgAndReload();
  const [createOrg, { loading }] = useCreateOrgMutation({
    onCompleted: (res) => {
      if (res.createOrg.success && res.createOrg.org) {
        switchOrgAndReload(res.createOrg.org?.id, res.createOrg.org?.name);
      }
    },
  });
  const { name, deactivatedAt, startedAt, seatsExpected, timezone, isTrial } =
    state;
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="flex h-[80vh] w-[460px] flex-col gap-0 overflow-hidden p-0">
        <DialogHeader className="shrink-0 border-b border-border p-4">
          <DialogTitle>Create Org</DialogTitle>
        </DialogHeader>
        <ScrollableFlexGrow flex={1} className="min-h-0" innerClassName="p-4">
          <OrgForm {...state} creating />
        </ScrollableFlexGrow>
        <DialogFooter className="shrink-0 border-t border-border p-4">
          <Button variant="outline" onClick={() => onOpenChange(false)}>
            Cancel
          </Button>
          <Button
            loading={loading}
            onClick={() => {
              createOrg({
                variables: {
                  input: {
                    name,
                    seatsExpected,
                    deactivatedAt: deactivatedAt
                      ? DateTime.fromJSDate(deactivatedAt).toISO()
                      : null,
                    startedAt: startedAt
                      ? DateTime.fromJSDate(startedAt).toISO()
                      : null,
                    timezone,
                    isTrial,
                  },
                },
              });
            }}
          >
            Create Org
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default CreateOrgDialog;

gql`
  mutation CreateOrg($input: OrgInput!) {
    createOrg(input: $input) {
      success
      org {
        id
        name
      }
    }
  }
`;
